import { render, staticRenderFns } from "./useCase2.vue?vue&type=template&id=18d2b504&"
import script from "./useCase2.vue?vue&type=script&lang=js&"
export * from "./useCase2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports